module.exports = __webpack_public_path__ + "23488fd1656b3a31fab9511bba492a20.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/es.json
// module id = 1154
// module chunks = 0